import { render, staticRenderFns } from "./QuickProtocolCreateList.vue?vue&type=template&id=a375fac0&scoped=true&"
import script from "./QuickProtocolCreateList.vue?vue&type=script&lang=js&"
export * from "./QuickProtocolCreateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a375fac0",
  null
  
)

export default component.exports